import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundToTwoDecimalPlaces'
})
export class RoundToTwoDecimalPlacesPipe implements PipeTransform {

  transform(value: string): string {
    return ((Math.round(parseFloat(value) * 100) / 100).toFixed(2));
  }

}
